import React, { useState } from 'react';
import { usePublicRaffles } from '../hooks/useRaffles';
import { useAuth } from '../context/AuthContext';
import { Container } from '../components/layout/Container';
import { Card } from '../components/common/Card';
import { Button } from '../components/common/Button';
import { Spinner } from '../components/common/Spinner';
import { RaffleCard } from '../components/raffle/RaffleCard';
import { Search } from 'lucide-react';

export const RaffleList: React.FC = () => {
  const [page, setPage] = useState(1);
  const { user } = useAuth();
  const countryCode = user?.countryCode || '';
  const { data, isLoading } = usePublicRaffles({ page, limit: 12, countryCode });

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-950 dark:to-gray-950">
        <Container className="py-12">
          <Spinner size="lg" />
        </Container>
      </div>
    );
  }

  const raffles = data?.data?.raffles || [];
  const pagination = data?.data?.pagination;

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-950 dark:to-gray-950">
      <Container className="py-10">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Browse Raffles</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-1">Find your next winning opportunity</p>
        </div>

        {raffles.length === 0 ? (
          <Card className="text-center py-16">
            <Search className="h-12 w-12 text-gray-200 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400 text-lg">No active raffles found</p>
            <p className="text-gray-400 dark:text-gray-500 text-sm mt-1">Check back soon for new raffles</p>
          </Card>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {raffles.map((raffle) => (
                <RaffleCard key={raffle.id} raffle={raffle} />
              ))}
            </div>

            {pagination && pagination.pages > 1 && (
              <div className="flex justify-center items-center gap-3 mt-10">
                <Button variant="outline" disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</Button>
                <span className="text-sm text-gray-500 dark:text-gray-400 px-3">Page {page} of {pagination.pages}</span>
                <Button variant="outline" disabled={page === pagination.pages} onClick={() => setPage(page + 1)}>Next</Button>
              </div>
            )}
          </>
        )}
      </Container>
    </div>
  );
};
